"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasStrategyData = exports.transformStrategyToElements = void 0;
var constants_1 = require("../../constants");
var LAYOUT_CONFIG = {
    columnSpacing: 250,
    nodeSpacing: 80,
    nodeWidth: 180,
    nodeHeight: 60,
    groupPadding: 40,
    groupHeaderHeight: 40,
};
var generateGrayVariant = function (index, total) {
    var lightestGray = 0xc6;
    var darkestGray = 0x9e;
    if (total === 1) {
        return '#888888';
    }
    var ratio = index / (total - 1);
    var grayValue = Math.round(lightestGray - (lightestGray - darkestGray) * ratio);
    var hex = grayValue.toString(16).padStart(2, '0');
    return "#" + hex + hex + hex;
};
/**
 * Transform strategy columns to ReactFlow elements
 */
exports.transformStrategyToElements = function (columns, onGroupClick) {
    var safeColumns = Array.isArray(columns) ? columns : [];
    var elements = [];
    var maxNodesInColumn = Math.max.apply(Math, __spreadArrays(safeColumns.map(function (col) { return (col.nodes || []).length; }), [1]));
    var fixedGroupHeight = maxNodesInColumn * LAYOUT_CONFIG.nodeHeight +
        (maxNodesInColumn - 1) * LAYOUT_CONFIG.nodeSpacing +
        LAYOUT_CONFIG.groupPadding * 2 +
        LAYOUT_CONFIG.groupHeaderHeight;
    var totalColumns = safeColumns.length;
    safeColumns.forEach(function (column, columnIndex) {
        var nodes = column.nodes || [];
        var columnX = columnIndex * LAYOUT_CONFIG.columnSpacing;
        var groupY = 0;
        var groupNode = {
            id: "group-" + column.id,
            type: 'group',
            data: {
                label: column.name,
                groupId: column.id,
                onGroupClick: onGroupClick,
            },
            position: { x: columnX, y: groupY },
            style: {
                width: LAYOUT_CONFIG.nodeWidth + LAYOUT_CONFIG.groupPadding * 2 - 16,
                height: fixedGroupHeight,
                zIndex: -1,
            },
            draggable: false,
            selectable: false,
            connectable: false,
        };
        elements.push(groupNode);
        var totalNodesHeight = nodes.length > 0
            ? nodes.length * LAYOUT_CONFIG.nodeHeight + (nodes.length - 1) * LAYOUT_CONFIG.nodeSpacing
            : 0;
        var availableContentHeight = fixedGroupHeight - LAYOUT_CONFIG.groupHeaderHeight - LAYOUT_CONFIG.groupPadding * 2;
        var verticalOffset = (availableContentHeight - totalNodesHeight) / 2;
        var nodeColors = nodes.map(function (_, index) { return generateGrayVariant(index, nodes.length); });
        nodes.forEach(function (node, nodeIndex) {
            var nodeY = groupY +
                LAYOUT_CONFIG.groupHeaderHeight +
                LAYOUT_CONFIG.groupPadding +
                verticalOffset +
                nodeIndex * (LAYOUT_CONFIG.nodeHeight + LAYOUT_CONFIG.nodeSpacing);
            var isFirstColumn = columnIndex === 0;
            var isLastColumn = columnIndex === totalColumns - 1;
            var nodeColor = nodeColors[nodeIndex];
            var elementNode = {
                id: node.id,
                type: 'element',
                data: {
                    label: node.name,
                    showLeftHandle: !isFirstColumn,
                    showRightHandle: !isLastColumn,
                    color: nodeColor,
                },
                position: {
                    x: columnX + LAYOUT_CONFIG.groupPadding,
                    y: nodeY,
                },
                style: {
                    width: LAYOUT_CONFIG.nodeWidth,
                    height: LAYOUT_CONFIG.nodeHeight,
                    zIndex: 100 - nodeIndex,
                },
                draggable: false,
                selectable: false,
            };
            elements.push(elementNode);
            var edges = node.edges || {};
            Object.entries(edges).forEach(function (_a) {
                var targetId = _a[0], edgeWeight = _a[1];
                var weightType = constants_1.parseEdgeWeight(edgeWeight);
                var labelText = constants_1.getEdgeWeightShortLabel(weightType);
                var edge = {
                    id: "e-" + node.id + "-" + targetId,
                    source: node.id,
                    target: targetId,
                    sourceHandle: 'right',
                    targetHandle: 'left',
                    type: 'custom',
                    animated: true,
                    label: labelText,
                    labelStyle: {
                        fontSize: '12px',
                        fontWeight: 700,
                        fill: '#323130',
                    },
                    labelBgStyle: {
                        fill: '#ffffff',
                        fillOpacity: 1,
                        strokeWidth: 1,
                        stroke: '#d8dce4',
                    },
                    labelBgPadding: [6, 8],
                    labelBgBorderRadius: 4,
                    labelShowBg: true,
                    style: {
                        stroke: '#c8ced9',
                        strokeWidth: 3,
                        strokeDasharray: '6, 6',
                    },
                    data: {
                        defaultColor: '#c8ced9',
                        sourceNodeId: node.id,
                        sourceGroupId: column.id,
                        originalLabel: labelText,
                    },
                    zIndex: 100,
                };
                elements.push(edge);
                if (labelText) {
                    var labelElement = {
                        id: edge.id + "-label",
                        type: 'labelEdge',
                        source: node.id,
                        target: targetId,
                        sourceX: 0,
                        sourceY: 0,
                        targetX: 0,
                        targetY: 0,
                        data: __assign(__assign({}, edge.data), { originalEdgeId: edge.id }),
                        label: labelText,
                        labelBgStyle: edge.labelBgStyle,
                        labelStyle: edge.labelStyle,
                        zIndex: 200,
                    };
                    elements.push(labelElement);
                }
            });
        });
    });
    return elements;
};
/**
 * Check if columns have any data to display
 */
exports.hasStrategyData = function (columns) {
    var safeColumns = Array.isArray(columns) ? columns : [];
    return safeColumns.some(function (col) { return col.nodes && col.nodes.length > 0; });
};
